import MenuButton from 'components/DropdownMenu/MenuButton';
import { Ellipsis } from 'lucide-react';

const CIRCLE =
  'flex h-8 w-8 items-center justify-center rounded-full border border-gray-100 text-gray-900 transition-colors group-hover:border-gray-200 group-hover:bg-gray-100';
const ACTION = 'group flex flex-col items-center gap-1.5 text-xs text-gray-700 transition-colors hover:text-gray-900';

const QuickAction = ({ icon: Icon, label, onClick }) => (
  <button type="button" onClick={onClick} className={ACTION}>
    <span className={CIRCLE}>
      <Icon wh={14} color="currentColor" />
    </span>
    {label}
  </button>
);

// The three dots of « Plus », as thin as the other icons.
const MoreIcon = ({ wh, color }) => <Ellipsis size={wh} color={color} strokeWidth={2} />;

/**
 * The row of the record's actions, as on the prototype: a round icon over
 * its name (Note, E-mail, Appel, Tâche, RDV…). An action with `menu` opens
 * a menu of those items; `more`: the items of a last « Plus » action.
 */
const QuickActions = ({ actions, more, moreLabel }) => (
  // Inset from the card edges: spread edge to edge, the actions read as too far apart.
  <div className="mt-4 flex justify-between px-4">
    {actions.map(({ menu, key, ...action }) =>
      menu ? (
        <MenuButton
          key={key}
          align="left"
          items={menu}
          trigger={(toggle) => <QuickAction {...action} onClick={toggle} />}
        />
      ) : (
        <QuickAction key={key} {...action} />
      ),
    )}
    {more?.length > 0 && (
      <MenuButton items={more} trigger={(toggle) => <QuickAction icon={MoreIcon} label={moreLabel} onClick={toggle} />} />
    )}
  </div>
);

export default QuickActions;
